// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"N1-z","dimensionLabel":"O1-z","styleChooserControlWrapper":"P1-z","styleChooserControl":"Q1-z","disabled":"R1-z","giftCard":"S1-z","styleChooserText":"T1-z"};